import React from 'react';
import SmartDialog from "../SmartDialog/SmartDialog";
import TTLProxy from "../../common/TTLAsyncProxy";
import {TrackerEndpoints, TractorsEndpoints} from "../../common/ProxyEndpoints";
import {ListItemView, PaginatedView} from "../PaginatedView/PaginatedView";
import {Badge, Button, ButtonGroup, ButtonToolbar, Col, FormGroup, Label, Row, UncontrolledAlert} from 'reactstrap';
import Utils, {exportCSV} from "../../common/Utils";
import MDSpinner from 'react-md-spinner';
import HTML from '../../common/HtmlHelpers';
import "./TrackerMapDialog.css";
import PropTypes from 'prop-types';
import PermissionRender, {hasAllPermissions} from "../PermissionRender/PermissionRender";
import {Permissions} from "../../common/Constants";
import StandardValue from "../../common/StandardValue";
import classnames  from 'classnames';
import TwoLineItemRender from "../Elements/TwoLineItemRender";
import ProfileAvatar from "../ProfileAvatar";
import {ExpanderView, SectionedList, TextField} from "../AuditExplorer/Elements";
import {CustomFilterFrame} from "../CRUDView";
import {Field, Formik  , Form } from "formik";
import PhoneNumberInput from "../PhoneNumberInput/PhoneNumberInput";
import * as yup from 'yup';
import _ from 'lodash';
import FormInput from "../FormInput";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import MDProgress from 'react-md-progress-bar';
import LoadingView from "../Elements/LoadingView";

const FilterOptions = [
    "All",
    "Unmapped",
    "Mapped"
];

class ListDevicesDialog extends React.Component{

    static  propTypes = {
        type: PropTypes.string,
        selectBtnText: PropTypes.string,
        onSelect: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = this.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    loadState(){

        const type = this.props.type;

        this.setState({
            isBusy: true
        });

        return this.proxy.processRequest(TrackerEndpoints.getAllSimple()).then(response => {

            const data = response.getPayload();

            this.setState({
                trackers: data,
                isBusy: false
            });

        }).catch(err =>{

            this.setState({
                isBusy: false
            });

        });

    }

    getInitialState(){

        return {
            trackers: null,
            isBusy: false,
            errorMessage: null,
            search: "",
            selectedTracker: null,
            allowRemove: false
        };

    }

    show(initialState){

        //
        initialState = initialState || {};

        //  get initial state of tractors
        this.setState(this.getInitialState());

        //
        this.loadState().then(() => {

            if(initialState.selected){

                this.setState({
                    selectedTracker: this.state.trackers.find(x => x.imei == initialState.selected),
                    allowRemove: true
                });

            }

        });

        this._dlg.show();
    }

    render(){

        const state = this.state;
        let trackers = this.state.trackers || [];
        const isBusy = state.isBusy;
        const btnSelectedDisabled = this.state.selectedTracker == null && this.state.allowRemove == false;
        let search = state.search;

        if(search){
            search = search.toLowerCase();
            trackers = trackers.filter(x => x.name.toLowerCase().indexOf(search) >= 0 || (x.phone && x.phone.toLowerCase().indexOf(search) >= 0) || x.imei.toLowerCase().indexOf(search) >= 0  || x.provider.toLowerCase().indexOf(search) >= 0);
        }


        return <SmartDialog ref={r => this._dlg = r} title={"Select Tracking Devices"} showCancelButton={false}>

            <input type="text" placeholder="Enter search keyword..." style={{marginTop: 5, marginBottom: 10  , width: "100%" }} className="form-control" onChange={evt => {

                const value = evt.target.value;
                this.setState({
                    search: value
                });

            }}/>

            {isBusy ? <div className="text-center">
                    <p>Loading tracking devices, please hold on...</p>
                    <MDSpinner/>
                </div>  :
                <div>

                    {trackers.length > 0 && <p>Click to select tracker device</p> }
                    <PaginatedView rowHeight={160}
                                   style={{}}
                                   height={310}
                                   noRowsHeight={310}
                                   data={trackers}
                                   emptyMessage={!search ? "No tracking devices available"  : "No tracking devices found for search given query or filters!"}
                                   renderItem={(item) => {

                                       return <div className={classnames("p-4",item === this.state.selectedTracker ? "selected-item" : "hover-item")}
                                                   onClick={() => {

                                                       //
                                                       this.setState(state => ({
                                                           selectedTracker: state.selectedTracker === item ? null : item
                                                       }));

                                                   }}>
                                           <h6><i className="fa fa-location-arrow"/> {item.name}</h6>
                                           <div><span><b>Platform</b>: {item.provider.toUpperCase()}</span></div>
                                           <div><span><b>IMEI</b>: {item.imei}</span></div>
                                           <div><span><b>SIM Card No</b>: <StandardValue value={item.phone}/></span></div>
                                       </div>

                                   }}/>
                    <hr/>
                    <div className="clearfix">

                        <div className="pull-left">
                            <b>Selected Device</b>
                            {this.state.selectedTracker ? <p>{state.selectedTracker.name} , {state.selectedTracker.imei}</p> : <p> <Badge pill={true}>Nothing</Badge> </p>}

                        </div>

                        <div className="pull-right">
                            <Button disabled={btnSelectedDisabled} outline={true} style={{borderRadius: 5}} color={ btnSelectedDisabled ? "secondary" : "primary"} onClick={() =>{

                                if(this.props.onSelect){
                                    this.props.onSelect(state.selectedTracker);
                                }

                                this._dlg.toggle();

                            }}><i className="fa fa-check"/> { (this.state.allowRemove && this.state.selectedTracker == null) ? "Remove Device" : this.props.selectBtnText || "Select Device"}</Button>
                        </div>

                    </div>

                </div>}
        </SmartDialog>;

    }
}

class FinalizeMappingDialog extends React.Component{

    static propTypes = {
        onConfirmed: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = FinalizeMappingDialog.getInitialState();
        this.onSubmit = this.onSubmit.bind(this);
        this.confirmationValidationSchema = yup.object().shape({
           confirmed: yup.bool().oneOf([true]).label("Confirmed"),
           comments: yup.string().max(256).notRequired().label("Comments"),
           phone: yup.string().required().label("SIM Card No").test("phone", "Invalid phone number", value =>
               Utils.validatePhoneNumber(value, this.getForm().values[`phone-region`])),
           installer_phone: yup.string().label("Installer's phone no.").test("installer_phone", "Invalid phone number", value =>
               value && value.trim() ? Utils.validatePhoneNumber(value, this.getForm().values[`installer_phone-region`]) : true )
        });
    }

    static getInitialState(tractor = null,tracker = null){

        return {
            tractor,
            tracker
        };

    }

    show(tractor,tracker){

        this.setState(FinalizeMappingDialog.getInitialState(tractor,tracker), () => {
           this._dlg.show();
        });

    }

    async onSubmit(values){

        if(this.props.onConfirmed){

            if(await this.props.onConfirmed(values)){
                this._dlg.hide();
            }

        }

    }

    getForm(){
        return this._confirmationForm.getFormikContext();
    }

    render() {

        const state = this.state;
        return <SmartDialog ref={r => this._dlg = r}
                            title="Map Tracking Device">

            {(state.tractor && state.tracker) && <React.Fragment>

                <p className="font-">Assign tracker <b>{state.tracker.imei}</b> to <b>{state.tractor.name} ({state.tractor.registration_number})</b>?</p>

                <CustomFilterFrame>

                    <ExpanderView title={"Tractor Info"} className="mb-2" isExpanded={false}>

                        <SectionedList items={[
                            {
                                title: "Name",
                                value: state.tractor.name
                            },
                            {
                                title: "Owner",
                                value: `${state.tractor.owner.name}`
                            },
                            {
                                title: "Registration Number",
                                value: state.tractor.registration_number
                            },
                            {
                                title: "Chassis",
                                value: state.tractor.chassis
                            },
                            {
                                title: "Model",
                                value: state.tractor.tractor_model
                            }
                        ]}/>

                    </ExpanderView>

                    <ExpanderView title={"Tracking Device"} isExpanded={false}>

                        <SectionedList items={[
                            {
                                title: "Name",
                                value: state.tracker.name
                            },
                            {
                                title: "Platform",
                                value: state.tracker.provider.toUpperCase()
                            },
                            {
                                title: "IMEI",
                                value: state.tracker.imei
                            },
                            {
                                title: "SIM Card",
                                value: <StandardValue value={state.tracker.phone}/>
                            }
                        ]}/>

                    </ExpanderView>

                </CustomFilterFrame>

                <Formik onSubmit={async (values,{ setSubmitting }) => {

                            try {

                                await this.onSubmit({
                                    ..._.pick(values,[
                                        'confirmed',
                                        'comments',
                                        'installation_position',
                                        'installer_name'
                                    ]),
                                    installation_date: values.installation_date ? moment(values.installation_date).toDate() : null,
                                    installation_location: values.installation_location? values.installation_location.text : null,
                                    installation_location_lat: values.installation_location ? values.installation_location.lat : null,
                                    installation_location_long: values.installation_location ? values.installation_location.lng : null,
                                    phone: Utils.fixPhone(values.phone,values['phone-region']),
                                    installer_phone: values.installer_phone ? Utils.fixPhone(values.installer_phone,values['installer_phone-region']) : null,
                                    ..._.pick(this.state,['tracker','tractor']),
                                });

                            }
                            catch (e) {

                            }
                            finally {
                                setSubmitting(false);
                            }

                        }}
                        ref={r => this._confirmationForm = r}
                        validationSchema={this.confirmationValidationSchema}
                        initialValues={{
                            confirmed: false,
                            comments: '',
                            phone: '',
                            installer_phone: '',
                            installer_name: '',
                            installation_location: null,
                            installation_position: '',
                            installation_date: new Date()
                        }}>
                    {({ isValid , isSubmitting , setFieldValue , values , errors }) => {

                        return <Form className="p-1">

                            <FormInput title={"SIM Card No."}
                                       name="phone"
                                       icon="fa fa-phone"
                                       type="phone"
                                       placeholder={"Enter SIM card number..."}/>


                            <FormInput title={"Installer Name"}
                                       name="installer_name"
                                       icon="fa fa-person"
                                       type="text"
                                       placeholder="Enter name of installer here..."/>


                            <FormInput title={"Installer Phone No."}
                                       name="installer_phone"
                                       icon="fa fa-phone"
                                       type="phone"
                                       placeholder="Enter phone no. of installer here..."/>


                            <FormInput type={"location"}
                                       title="Installation Address/Location"
                                       name={"installation_location"}
                                       icon="fa fa-map-marker"
                                       inputClass="form-input-select"
                                       placeholder={"Enter address/location where installation was done"}/>


                            <FormInput title={"Installation Position"}
                                       name="installation_position"
                                       type="text"
                                       icon={"fa fa-eye"}
                                       placeholder="Enter position in vehicle tracker was attached"/>

                            <FormGroup>
                                <Label><i className="fa fa-calendar"/> Installation Date</Label>
                                <div>
                                    <DatePicker selected={values.installation_date}
                                                className={"form-control form-input"}
                                                isClearable
                                                showTimeInput
                                                placeholderText="Select date/time installation was done"
                                                onChange={date => {
                                                    setFieldValue('installation_date',date);
                                                }}/>
                                </div>
                            </FormGroup>

                            <FormGroup>
                                <Label>Remarks</Label>
                                <textarea rows={3}
                                          className="form-control form-input-select"
                                          value={values.comments}
                                          maxLength={512}
                                          placeholder={"Enter some remarks or comments here..."}
                                          onChange={evt => {
                                              setFieldValue('comments',evt.target.value);
                                          }}/>

                            </FormGroup>

                            <div style={{ background: "#eeeeee" }} className="p-2">

                                <span>
                                    <input type="checkbox" checked={values.confirmed} onChange={evt => {

                                        setFieldValue('confirmed',evt.target.checked);

                                    }}/> Confirm device mapping?
                                </span>

                            </div>

                            {errors.confirmed && Object.keys(errors).length === 1 ? <UncontrolledAlert color={"info"} className="mt-2"><i className="fa fa-info-circle"/> Please check <b>confirm device mapping</b> to proceed</UncontrolledAlert> : null}

                            <hr/>

                            {isSubmitting && <MDProgress show/>}

                            <Button color="green" block disabled={isSubmitting}><i className="fa fa-check"/> Map Device</Button>

                        </Form>

                    }}
                </Formik>


            </React.Fragment>}

        </SmartDialog>

    }

}

class MappingInfoDialog extends React.Component {

    static propTypes = {
      onRemove: PropTypes.func,
      onChange: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = MappingInfoDialog.getInitialState();
        this._handleRemove = this._handleRemove.bind(this);
        this._handleChangeDevice = this._handleChangeDevice.bind(this);
    }

    static getInitialState(tractor){

        return {
            tractor: tractor || null,
            isFetchingInfo: false,
            trackerInfoUpdated: false
        };

    }

    show(tractor){
        this.setState(MappingInfoDialog.getInitialState(tractor), () => this._dlg.show());
    }

    async _handleRemove(){

        if(this.props.onRemove){

            if(await this.props.onRemove(this.state.tractor)){
                this._dlg.hide();
            }

        }

    }

    async _handleChangeDevice(){

        //  before
        this._dlg.hide();

        if(this.props.onChange){
            await this.props.onChange(this.state.tractor);
        }

    }

    async loadState(){

        try {

            const { tractor } = this.state;

            this.setState({ isFetchingInfo : true , trackerInfoUpdated: false });

            const proxy = TTLProxy.getInstance();

            const response = await proxy.processRequest({
                ...TractorsEndpoints.getTracker(tractor.id),
                include: ['assigned_by']
            });

            this.setState({

                tractor: {
                    ...tractor,
                    tracker: response.getPayload()
                },

                trackerInfoUpdated: true

            });

        }
        catch (e) {
            this.setState({ trackerInfoUpdate: null });
        }
        finally {
            this.setState({ isFetchingInfo : false });
        }

    }


    render(){

        const state = this.state;
        const tractor = state.tractor;

        return <SmartDialog ref={r => this._dlg = r}
                            title="Mapping Info">

            {tractor && <div>

                <ExpanderView title={"Mapping Info"} isExpanded>

                    <SectionedList items={[
                        {
                            title: "Tractor",
                            value: `${tractor.name} (${tractor.registration_number})`
                        },
                        {
                            title: "Tracker IMEI",
                            value: tractor.tracker.imei
                        },
                        {
                            title: "SIM Card No.",
                            value: <StandardValue value={tractor.tracker.phone}/>
                        },
                        {
                            title: "Device Platform",
                            value: tractor.tracker.provider.toUpperCase()
                        },
                        {
                            title: "Device Model",
                            value: tractor.tracker.model
                        },
                        {
                            title: "Status",
                            value: tractor.tracker.tracker_enabled ? "Enabled" : "Disabled"
                        },
                        {
                            title: "Notifications",
                            value: tractor.tracker.alerts_enabled ? "Enabled" : "Disabled"
                        },
                        {
                            title: "Time Assigned",
                            value: Utils.formatDateLong(tractor.tracker.date_created)
                        },
                        {
                            title: "Comments",
                            mode: "vertical",
                            value: <TextField text={tractor.tracker.comments || "None"}/>
                        }
                    ]}/>

                </ExpanderView>

                <ExpanderView title={"Installation Info"}
                              isExpanded>

                    <SectionedList items={[
                        {
                            title: "Installer Name",
                            value: <StandardValue value={tractor.tracker.installer_name}/>
                        },
                        {
                            title: "Installer Phone",
                            value: <StandardValue value={tractor.tracker.installer_phone}/>
                        },
                        {
                            title: "Installation Position",
                            value: <StandardValue value={tractor.tracker.installation_position}/>
                        },
                        {
                            title: "Installation Date",
                            value: <StandardValue value={tractor.tracker.installation_date}>
                                {Utils.formatDateLong(tractor.tracker.installation_date)}
                            </StandardValue>
                        },
                        {
                            title: "Address/Location",
                            value: <StandardValue value={tractor.tracker.installation_location}/>
                        }
                    ]}/>

                </ExpanderView>

                <ExpanderView title="Assignment Info" onExpand={async () => {

                    if(this.state.trackerInfoUpdated !== true)
                        await this.loadState();

                }}>
                    <LoadingView message={"Fetching assignment info..."} isBusy={this.state.isFetchingInfo}>
                        {tractor.tracker.assigned_by ? <CustomFilterFrame>
                            <TwoLineItemRender line1Value={Utils.getUserName(tractor.tracker.assigned_by)}
                                               line2Prefix={"Account Type"}
                                               media={Utils.getUserEntityMedia(tractor.tracker.assigned_by)}
                                               line2Value={Utils.formatRole(tractor.tracker.assigned_by.role)}/>
                        </CustomFilterFrame> : <div className="text-center">
                            <p>{tractor.tracker.assigned_by === null ?  "Information not available" : "Failed fetching assignment info"}</p>
                        </div>}
                    </LoadingView>
                </ExpanderView>

                <hr/>

                <Row className="no-gutters">

                    <Col md={8} >
                        <Button block onClick={() => this._handleChangeDevice()}><i className="fa fa-cog"/> Modify Device</Button>
                    </Col>

                    <Col md={4}>
                        <Button className="ml-1"
                                block
                                outline
                                onClick={() => this._handleRemove()}
                                color="danger"><i className="fa fa-remove"/> Remove</Button>
                    </Col>

                </Row>

            </div>}

        </SmartDialog>;

    }

}

class TrackerMapDialog extends React.Component{

    static MapPermissions = [
      Permissions.Trackers.Edit
    ];

    static InstallPermissions = [
      Permissions.Trackers.Install
    ];

    constructor(props){
        super(props);
        this.state = TrackerMapDialog.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(selected){

        return {
            tractors: null,
            filteredTractors: null,
            summary: {
                totalMapped: 0,
                totalUnmapped: 0
            },
            filters: "all",
            search: "",
            isBusy: false,
            filterOptionsOpen: false,

            //  tractor whose tracker is being mapped or changed
            contextTractor: null
        };

    }


    show(){

        //  Set initial state
        this.setState(TrackerMapDialog.getInitialState());

        //  Load state
        this.loadState();

        //  Finally, show dialog
        this._dlg.show();
    }

    loadState(){

        const state = this.state;

        this.setState({
            isBusy: true
        });

        return Promise.all([

            this.proxy.processRequest(TractorsEndpoints.getActiveTractors().url,{
                method: "get",
                include: [ "tracker", "owner", "operator" ],
            }).then(response => {

                const tractors = response.getPayload();
                this.setState({
                    tractors: tractors,
                    summary: {
                        totalMapped: tractors.filter(x => x.tracker != null).length,
                        totalUnmapped: tractors.filter(x => x.tracker == null).length
                    }
                });

            })

        ]).then(values => {

            this.setState({
                isBusy: false
            });

        }).catch(err => {

            HTML.toastWarning(Utils.getResponseError(err));

            this.setState({
                isBusy: false
            });

        });

    }

    filterTractors(tractors){

        switch (this.state.filters){
            case "unmapped":
                return tractors.filter(x => x.tracker == null);
            case "mapped":
                return tractors.filter(x => x.tracker != null);
            case "all":
                return tractors;
        }

    }


    _executeEndpoint(endpoint){

        return this.proxy.processRequest( endpoint ).then(async response => {

            HTML.toastSuccess("Operation completed successfully!");

            //  Refresh View
            await this.loadState();

            //
            return true;

        }).catch(err => {
            HTML.toastWarning(Utils.getResponseError(err));
        });

    }


    onTrackerSelected(tracker,params){

        const tractor = this.state.contextTractor;

        if(!tracker && tractor.tracker){

            //  Remove GPS Tracker
            return this._executeEndpoint(TrackerEndpoints.removeTracker(tractor.tracker.id));

        }
        else if(tracker && !tractor.tracker){

            //  Map New Tracker
            return this._executeEndpoint(TrackerEndpoints.installTracker(tractor.id , {
                imei: tracker.imei,
                provider: tracker.provider,
                phone: tracker.phone,
                ...params
            }));

        }
        else if(tractor && tractor.tracker){

            return this.proxy.processRequest(TrackerEndpoints.removeTracker(tractor.tracker.id)).then(res => {

                return this._executeEndpoint(TrackerEndpoints.installTracker(tractor.id , {
                    imei: tracker.imei,
                    provider: tracker.provider,
                    ..._.pick(tractor.tracker,[
                        'comments',
                        'installation_position',
                        'installer_name',
                        'installation_date',
                        'installation_location',
                        'installation_location_lat',
                        'installation_location_long',
                        'phone',
                        'installer_phone',
                    ])
                }));

            }).catch(err => {
                HTML.toastWarning(Utils.getResponseError(err));
            });

        }

    }

    _handleTractorClicked(tractor){

        this.setState({
            contextTractor: tractor
        }, () => this._listDevicesDlg.show({ selected: tractor.tracker ? tractor.tracker.imei : undefined  }  ));

    }

    _removeMappingInstant(tractor){

        if(window.confirm('Remove assigned tracker ' + tractor.tracker.imei + '?')){

            this.setState({
                contextTractor: tractor
            }, () => this.onTrackerSelected(null));

            return true;
        }

    }

    render(){

        const state = this.state;
        const summary = state.summary;
        const isBusy = state.isBusy;
        let search =  state.search;
        let tractors = state.tractors || [];
        const totalTractors =  tractors.length;

        if(search){
            search = search.toLowerCase();
            tractors = state.filteredTractors || [];
        }

        tractors = this.filterTractors(tractors);

        return <SmartDialog ref={dlg => this._dlg = dlg} title={"Configure Tracking Devices"} large={true} showCancelButton={true} >

            <div>
                <div className="clearfix">

                    <div className="pull-left">
                        <h6>
                            <Badge color="primary" className="ml-2" pill={false}>Total Tractors: <b>{totalTractors}</b></Badge>
                            <Badge color="success" className="ml-2" pill={false}>Mapped: <b>{summary.totalMapped}</b></Badge>
                            <Badge pill={false} className="ml-2">Unmapped: <b>{summary.totalUnmapped}</b></Badge>
                        </h6>
                    </div>

                    <div className="pull-right">

                        <Row className="no-gutters">

                            <Col md={5}>
                                <select className="form-control"
                                        value={this.state.filters}
                                        onChange={(evt) => {

                                            this.setState({
                                                filters: evt.target.value
                                            });

                                        }}>
                                    {FilterOptions.map((x,index) => <option key={index} value={x.toLowerCase()}>{x}</option>)}
                                </select>
                            </Col>

                            <Col md={7}>
                                <Button block className="ml-1" onClick={() => exportCSV(TrackerEndpoints.exportCSV(false))}><i className="fa fa-file"/> Export CSV</Button>
                            </Col>



                        </Row>

                    </div>

                </div>


                {this.state.search && <div className="text-left mb-2">
                    Search results for "<b>{this.state.search}</b>" - <b>{tractors.length}</b> tractor{tractors.length > 1 ? 's' : ''} found
                </div>}


                <input type="text" className="form-control"  value={this.state.search} style={{minWidth: 120, borderRadius: 4 , marginTop: 10}} placeholder="Search devices & tractors here..." onChange={evt =>{

                    const search = evt.target.value.toLowerCase();

                    this.setState({
                        search: evt.target.value,
                        filteredTractors: search.trim() ? tractors.filter(x => x.name.toLowerCase().includes(search) ||
                            (x.operator ? x.operator.name.toLowerCase().includes(search) : false) ||
                            (x.tracker ? x.tracker.imei.toLowerCase().includes(search) : false) ||
                            x.tractor_model.toLowerCase().includes(search) ||
                            x.registration_number.toLowerCase().includes(search)  ||
                            x.owner.name.toLowerCase().includes(search) ||
                            x.chassis.toLowerCase().includes(search)) : tractors
                    });

                }}/>


                <hr/>

                {isBusy ? <div className="text-center">
                    <p>Please hold on, loading tractors...</p>
                    <MDSpinner/>
                </div> : <PaginatedView height={450}
                                        style={{}}
                                        noRowsHeight={450}
                                        emptyMessage={  (!search && state.filters === "all") ? "" : "" }
                                        rowHeight={165}
                                        data={tractors} renderItem={(item) => {

                    const handleItemClicked = (evt) => {

                        if(evt)
                            evt.stopPropagation();

                        return this._handleTractorClicked(item);
                    };

                    const showTrackerInfo = () => {

                        if(!hasAllPermissions(TTLProxy.getInstance().getUserInfo().permissions,item.tracker != null ? TrackerMapDialog.MapPermissions : TrackerMapDialog.InstallPermissions))
                            return;

                        if(!item.tracker){
                            return handleItemClicked();
                        }

                        return this._mappingInfoDlg.show(item);
                    };

                    return <div className="clearfix hover-item p-3" onClick={showTrackerInfo}>

                        <div style={{display: "inline"}} className="pull-left">
                            <ProfileAvatar size={36}
                                           media={item.media}
                                           showFullscreen={false}
                                           name={Utils.formatAvatarName(item.name)}/>
                        </div>

                        <div style={{ marginLeft: 80 }}>
                            <h6 className="mb-1">{item.name} ({item.registration_number})</h6>
                            <p className="mb-0">Driver: {item.operator ? item.operator.name : <StandardValue/>}</p>
                            <p className="mb-0">Owner: {item.owner.name}</p>
                            <p className="mb-1">Tracker: {item.tracker == null ? <Badge pill={true}>Unmapped</Badge> : <Badge pill={true} color={"success"}>IMEI: {item.tracker.imei}</Badge>}</p>
                            {item.tracker != null && <p className="mb-0">SIM Card No: <StandardValue value={item.tracker.phone}/></p>}

                            <PermissionRender required={item.tracker != null ? TrackerMapDialog.MapPermissions : TrackerMapDialog.InstallPermissions}>
                                <ButtonGroup>
                                    <Button style={{ borderRadius: 5 , marginRight: 15 }}
                                            size={"sm"}
                                            color={"primary"}
                                            className="btn-link"
                                            onClick={handleItemClicked}>
                                        <i className="fa fa-wrench"/> {item.tracker != null ? "Change Mapped Device" : "Map Device" }
                                    </Button>
                                    {item.tracker !== null && <Button style={{ borderRadius: 5  }}
                                            size={"sm"}
                                            color={"danger"}
                                            className="btn-link"
                                            onClick={(evt) => {

                                                if(evt)
                                                    evt.stopPropagation();

                                                return this._removeMappingInstant(item);
                                            }}>
                                        <i className="fa fa-remove" style={{ color: "red" }}/> Remove
                                    </Button>}
                                </ButtonGroup>

                            </PermissionRender>

                        </div>

                    </div>
                }}/>}

            </div>


            <MappingInfoDialog ref={r => this._mappingInfoDlg = r}
                               onChange={(tractor) => {
                                   this._handleTractorClicked(tractor);
                               }}
                               onRemove={(tractor) => {
                                   return this._removeMappingInstant(tractor);
                               }}/>

            <ListDevicesDialog ref={r => this._listDevicesDlg = r}
                               type={state.filters}
                               onSelect={tracker => {

                                   const tractor = this.state.contextTractor;
                                   if(tracker && !tractor.tracker){
                                       return this._finalizeDeviceMapping.show(tractor,tracker);
                                   }

                                   return this.onTrackerSelected(tracker);
                               }}/>


            <FinalizeMappingDialog ref={r => this._finalizeDeviceMapping = r}
                                   onConfirmed={({ confirmed , tractor , tracker , ...params }) => {

                                       if(confirmed){

                                           //   on tracker selected
                                           return this.onTrackerSelected(tracker,params);
                                       }

                                   } }/>


        </SmartDialog>;

    }

}

export default TrackerMapDialog;



// WEBPACK FOOTER //
// ./src/components/TrackerMapDialog/TrackerMapDialog.js